module.exports = __webpack_public_path__ + "img/9B9994_E1E0DB_474643_544C4C-256px.3f24e214.png";